export default __webpack_public_path__ + "static/mariakt-adb84cc0101eeb7cffdfe18aac6c8f10.jpg";